export const IS_OPEN_SIDEBAR = 'IS_OPEN_SIDEBAR'
export const IS_LOADING_SIDEBAR = 'IS_LOADING_SIDEBAR'
